import { initializeApp } from "firebase/app";
import { 
    getAuth, 
    GoogleAuthProvider,
    signInWithPopup,
    signOut,
    setPersistence,
    browserLocalPersistence
} from "firebase/auth";
import { 
    getFirestore, 
    collection, 
    addDoc,
    getDocs,
    query,
    where,
    orderBy
} from "firebase/firestore";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { firebaseConfig } from "./firebase_config";

// const firebaseConfig = {
//     apiKey: "AIzaSyDNCO2m6BrILNpnTLVfkLfxVJLW13WrWDA",
//     authDomain: "great-lake-1b8f7.firebaseapp.com",
//     projectId: "great-lake-1b8f7",
//     storageBucket: "great-lake-1b8f7.firebasestorage.app",
//     messagingSenderId: "1234567890",
//     appId: "1:1234567890:web:abcdef1234567890"
// };

// 初始化 Firebase
const app = initializeApp(firebaseConfig);

// 导出常用的 Firebase 服务
export const auth = getAuth(app);
export const db = getFirestore(app);

// 初始化Storage并添加额外配置
export const storage = getStorage(app);

// 如果是本地开发环境，可以尝试使用Storage模拟器
// 注意：需要先启动Firebase模拟器 firebase emulators:start
if (window.location.hostname === 'localhost') {
    // 取消注释下面的代码以使用Storage模拟器
    // connectStorageEmulator(storage, 'localhost', 9199);
}

// 初始化 Google 认证提供者
const provider = new GoogleAuthProvider();
provider.setCustomParameters({
    prompt: 'select_account'
});

// 认证相关函数
export const signInWithGoogle = async () => {
    try {
        // 确保在调用登录之前设置持久化
        await setPersistence(auth, browserLocalPersistence);
        const result = await signInWithPopup(auth, provider);
        return result.user;
    } catch (error: any) {
        console.error("Error signing in with Google:", error);
        if (error.code === 'auth/popup-closed-by-user') {
            console.log('User closed the popup');
            return null;
        }
        // 处理其他错误
        if (error.code === 'auth/invalid-api-key') {
            console.error('Invalid API key');
        }
        throw error;
    }
};

export const signOutUser = async () => {
    try {
        await signOut(auth);
    } catch (error) {
        console.error("Error signing out:", error);
        throw error;
    }
};

// Firestore 相关函数示例
export const addDocument = async (collectionName: string, data: any) => {
    try {
        const docRef = await addDoc(collection(db, collectionName), data);
        return docRef.id;
    } catch (error) {
        console.error("Error adding document", error);
        throw error;
    }
};

export const getDocuments = async (
    collectionName: string,
    whereConditions?: [string, any, any][],
    orderByField?: string
) => {
    try {
        let q = query(collection(db, collectionName));
        
        if (whereConditions) {
            whereConditions.forEach(([field, operator, value]) => {
                q = query(q, where(field, operator, value));
            });
        }

        if (orderByField) {
            q = query(q, orderBy(orderByField));
        }

        const querySnapshot = await getDocs(q);
        return querySnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
        }));
    } catch (error) {
        console.error("Error getting documents", error);
        throw error;
    }
}; 